
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Phone, MessageCircle, User, QrCode } from 'lucide-react';

const CommercialModal = ({
  isOpen,
  onClose,
  contacts = [],
  corPrincipal = "#25D366",
  nomeFeira = "Evento"
}) => {
  const formatPhone = (number) => {
    if (!number) return "";
    const cleaned = ('' + number).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return number;
  };

  const getWhatsAppLink = (number) => {
    const cleaned = ('' + number).replace(/\D/g, '');
    const msg = encodeURIComponent(`Olá, gostaria de informações sobre a feira ${nomeFeira}`);
    return `https://wa.me/55${cleaned}?text=${msg}`;
  };

  const getQRCodeUrl = (number) => {
    const link = encodeURIComponent(getWhatsAppLink(number));
    return `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${link}`;
  };

  if (!isOpen) return null;

  const modalContent = (
    <AnimatePresence>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 999999,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(4px)',
          padding: '24px'
        }}
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.96, y: 12 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.96, y: 12 }}
          transition={{ duration: 0.18 }}
          style={{
            backgroundColor: 'white',
            borderRadius: '1.25rem',
            overflow: 'hidden',
            width: '95%',
            maxWidth: contacts.length > 1 ? '1180px' : '420px',
            maxHeight: '90vh',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            position: 'relative'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              backgroundColor: corPrincipal,
              padding: '1.25rem 1.5rem',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              color: 'white'
            }}
          >
            <div>
              <h2 style={{ margin: 0, fontSize: '1.35rem', fontWeight: '800' }}>
                Contato
              </h2>
              <p style={{ margin: 0, fontSize: '0.9rem', opacity: 0.92 }}>
                Equipe comercial - {nomeFeira}
              </p>
            </div>

            <button
              onClick={onClose}
              style={{
                background: 'rgba(255,255,255,0.18)',
                border: 'none',
                borderRadius: '50%',
                width: '38px',
                height: '38px',
                cursor: 'pointer',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <X size={20} />
            </button>
          </div>

          <div style={{ padding: '1.25rem', maxHeight: 'calc(90vh - 88px)', overflowY: 'auto' }}>
            <div
              style={{
                display: 'grid',
                gap: '1rem',
                gridTemplateColumns: contacts.length > 1
                  ? 'repeat(auto-fit, minmax(220px, 1fr))'
                  : '1fr'
              }}
            >
              {contacts.map((contato, index) => (
                <div
                  key={index}
                  style={{
                    border: '1px solid #eef2f7',
                    borderRadius: '0.875rem',
                    padding: '1rem',
                    backgroundColor: '#f9fafb',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
                  }}
                >
                  <div
                    style={{
                      width: '2.75rem',
                      height: '2.75rem',
                      borderRadius: '50%',
                      backgroundColor: `${corPrincipal}15`,
                      color: corPrincipal,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '0.75rem'
                    }}
                  >
                    <User size={22} />
                  </div>

                  <h3 style={{
                    fontSize: '1rem',
                    fontWeight: '700',
                    color: '#111827',
                    margin: '0 0 0.75rem 0',
                    lineHeight: 1.2
                  }}>
                    {contato.nome}
                  </h3>

                  <div style={{
                    backgroundColor: 'white',
                    padding: '0.5rem',
                    borderRadius: '0.75rem',
                    marginBottom: '0.75rem',
                    border: '1px solid #e5e7eb'
                  }}>
                    <img
                      src={getQRCodeUrl(contato.whatsapp_principal)}
                      alt="QR Code WhatsApp"
                      style={{ width: '110px', height: '110px', display: 'block' }}
                    />
                  </div>

                  <p style={{
                    fontSize: '9px',
                    color: '#9ca3af',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    fontWeight: '700',
                    marginBottom: '0.75rem'
                  }}>
                    <QrCode size={11} style={{ verticalAlign: 'middle', marginRight: '4px' }} />
                    Digitalize o código
                  </p>

                  <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                      fontSize: '0.875rem',
                      fontFamily: 'monospace',
                      fontWeight: '700',
                      color: '#374151',
                      backgroundColor: 'white',
                      padding: '0.5rem 0.625rem',
                      borderRadius: '0.5rem',
                      border: '1px solid #e5e7eb'
                    }}>
                      <Phone size={15} style={{ color: corPrincipal, flexShrink: 0 }} />
                      {formatPhone(contato.whatsapp_principal)}
                    </div>

                    <a
                      href={getWhatsAppLink(contato.whatsapp_principal)}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.45rem',
                        width: '100%',
                        padding: '0.65rem 0.75rem',
                        borderRadius: '0.5rem',
                        fontWeight: '700',
                        fontSize: '0.95rem',
                        color: 'white',
                        backgroundColor: corPrincipal,
                        textDecoration: 'none'
                      }}
                    >
                      <MessageCircle size={16} />
                      Conversar agora
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default CommercialModal;